<template>
    <div class="pt-2">
        <div class="px-6 d-flex align-center justify-space-between flex-wrap">
            <div style="min-width: 350px" class="flex-equal flex-grow-1">
                <v-switch
                        :disabled="curUserLimitations.includes('uast')"
                        v-model="pref.access.statistics"
                        label="Statistics"
                        hint="User And Team Statistics"
                        persistent-hint
                        color="primary"
                        class="pt-0 mt-0 pb-3"
                ></v-switch>
            </div>
            <div style="min-width: 350px" class="flex-equal flex-grow-1">
                <v-switch
                    :disabled="curUserLimitations.includes('uasc')"
                        v-model="pref.access.screenshots"
                        label="Screenshots"
                        hint="Allow user to view screenshots"
                        persistent-hint
                        color="primary"
                        class="pt-0 mt-0 pb-3"
                ></v-switch>
            </div>
        </div>
        <div class="px-6 d-flex align-center justify-space-between flex-wrap">
            <div style="min-width: 350px" class="flex-equal flex-grow-1">
                <v-switch
                    :disabled="curUserLimitations.includes('uau')"
                        v-model="pref.access.users"
                        label="Users"
                        hint="Access to the Users Setup Screen"
                        persistent-hint
                        color="primary"
                        class="pt-0 mt-0 pb-3"
                ></v-switch>
            </div>
            <div style="min-width: 350px" class="flex-equal flex-grow-1">
                <v-switch
                    :disabled="curUserLimitations.includes('uas')"
                        v-model="pref.access.setup"
                        label="Setup"
                        hint="Access to the Devices, Employees and Teams Setup Screens"
                        persistent-hint
                        color="primary"
                        class="pt-0 mt-0 pb-3"
                ></v-switch>
            </div>
        </div>
        <div class="px-6 d-flex align-center justify-space-between flex-wrap">

            <div style="min-width: 350px" class="flex-equal flex-grow-1">
                <v-switch
                    :disabled="curUserLimitations.includes('uacl')"
                    v-model="pref.access.classification"
                    label="Classification"
                    hint="Access to the classification setup screen"
                    persistent-hint
                    color="primary"
                    class="pt-0 mt-0 pb-3"
                ></v-switch>
            </div>
            <div style="min-width: 350px" class="flex-equal flex-grow-1">
                <v-switch
                    :disabled="curUserLimitations.includes('uaad')"
                    v-model="pref.access.billing"
                    label="Admin"
                    hint="Access to billing and company information"
                    persistent-hint
                    color="primary"
                    class="pt-0 mt-0 pb-3"
                ></v-switch>
            </div>
        </div>
        <div class="px-6 d-flex align-center justify-space-between flex-wrap">
            <div style="min-width: 350px" class="flex-equal flex-grow-1">
                <v-switch
                    :disabled="curUserLimitations.includes('uamt')"
                    v-model="pref.access.approvals"
                    label="Manual Time"
                    hint="Access to the manual time approval screen"
                    persistent-hint
                    color="primary"
                    class="pt-0 mt-0 pb-3"
                ></v-switch>
            </div>
            <div style="min-width: 350px" class="flex-equal flex-grow-1">
                <v-switch
                    :disabled="curUserLimitations.includes('uale')"
                    v-model="pref.access.leave"
                    label="Leave"
                    hint="Access to manage employee leave records"
                    persistent-hint
                    color="primary"
                    class="pt-0 mt-0 pb-3"
                ></v-switch>
            </div>
        </div>
        <div class="px-6 d-flex align-center justify-space-between flex-wrap pt-2" v-if="pref.access.users">
            <v-btn
                :disabled="curUserLimitations.includes('uar')"
                text
                color="primary"
                block
                @click="showRestrictions = true"
            >
                Set Restrictions For User Screen
            </v-btn>
        </div>

        <div class="px-3 pt-4 pb-2 d-flex justify-end">
            <v-btn
                    ref="passwordBtn"
                    :disabled="savingChanges"
                    color="primary"
                    @click="resetValues"
                    small
                    outlined
                    class="mr-2"
            >
                Cancel
            </v-btn>

            <v-btn
                    ref="passwordBtn"
                    :disabled="!changesMade || savingChanges"
                    :loading="savingChanges"
                    color="primary"
                    @click="saveChanges"
                    small
            >
                Save Changes
            </v-btn>
        </div>

        <app-dlg
            v-if="showRestrictions"
            :show-dlg.sync="showRestrictions"
            title="User Screen Restrictions"
            :default-padding="false"
        >

            <div>
                <div class="body-2 px-2">
                    {{ "Select which options to disable from the users screen for " + selectedUser.name }}
                </div>
                <div style="max-height: 500px" class="of-y">
                    <v-treeview
                        selectable
                        selected-color="primary"
                        :items="restrictionTree"
                        v-model="pref.userRestrictions"
                        item-text="text"
                        item-children="children"
                        item-key="id"
                        dense
                        selection-type="leaf"
                    ></v-treeview>
                </div>
            </div>


            <template v-slot:actions>
                <v-btn
                    @click="showRestrictions = false"
                    small
                    class="ml-2"
                    color="secondary"
                    variant="contained"
                    size="small"
                >
                    Done
                </v-btn>
            </template>
        </app-dlg>

    </div>
</template>

<script>
import {UserSitePref} from "@/models/userSitePref";
import {mapGetters} from "vuex";
import AppList from "@/components/Shared/AppList/AppList.vue";
import AppDlg from "@/components/Shared/AppDlg.vue";

export default {
    components: {AppDlg, AppList},
    props: {
        userId: String,
    },
    data() {
        return {
            savingChanges: false,
            pref: new UserSitePref({userId: this.userId}),
            restrictionTree: [
                {
                    id: 'uo',
                    text: 'User Options',
                    children: [
                        {id: 'uoan', text: 'Account Name'},
                        {id: 'uoun', text: 'User Name'},
                        {id: 'uop', text: 'Change Password'},
                        {id: 'uopl', text: 'Send Password Reset'},
                        {id: 'uoto', text: 'TOTP Options'},
                        {id: 'uoen', text: 'Enable/Disable User'},
                    ]
                },
                {
                    id: 'ua',
                    text: 'User Access',
                    children: [
                        {id: 'uast', text: 'Statistics Switch'},
                        {id: 'uau', text: 'Users Switch'},
                        {id: 'uacl', text: 'Classifications Switch'},
                        {id: 'uasc', text: 'Screenshots Switch'},
                        {id: 'uas', text: 'Setup Switch'},
                        {id: 'uaad', text: 'Admin Switch'},
                        {id: 'uamt', text: 'Manual Time Switch'},
                        {id: 'uale', text: 'Leave Switch'},
                        {id: 'uar', text: 'Set User Screen Restrictions'},
                    ]
                },
                {
                    id: 'lt',
                    text: 'Limit To Teams',
                    children: [
                        {id: 'lta', text: 'Add Team'},
                        {id: 'ltr', text: 'Remove Team'},
                    ]
                },
            ],
            showRestrictions: false
        }
    },
    watch: {
        userId: {
            immediate: true,
            handler(val) {
                this.resetValues(val)
            }
        }
    },
    methods: {
        resetValues(val) {
            if (val) {
                this.pref = new UserSitePref(JSON.parse(JSON.stringify(this.usersSitePrefsRef[this.userId])))
            }
        },
        async saveChanges() {
            try {
                this.savingChanges = true;
                const res = await this.$newReq('POST', `users/updatePrefs`, this.pref)
            } catch (e) {
                console.log(e)
                this.$snack.netWorkError()
            } finally {
                this.savingChanges = false;
            }
        },
    },
    computed: {
        ...mapGetters(['usersSitePrefsRef', 'usersRef', 'user']),

        selectedUser() {
            return this.usersRef[this.userId]
        },

        curUserLimitations() {
            return this.usersSitePrefsRef[this.user._id] && this.usersSitePrefsRef[this.user._id].userRestrictions ? this.usersSitePrefsRef[this.user._id].userRestrictions : []
        },

        changesMade() {
            if (!this.usersSitePrefsRef[this.userId])
                return true
            if (this.pref.access.statistics !== this.usersSitePrefsRef[this.userId].access.statistics)
                return true
            if (this.pref.access.screenshots !== this.usersSitePrefsRef[this.userId].access.screenshots)
                return true
            if (this.pref.access.users !== this.usersSitePrefsRef[this.userId].access.users)
                return true
            if (this.pref.access.setup !== this.usersSitePrefsRef[this.userId].access.setup)
                return true
            if (this.pref.access.classification !== this.usersSitePrefsRef[this.userId].access.classification)
                return true
            if (this.pref.access.billing !== this.usersSitePrefsRef[this.userId].access.billing)
                return true
            if (this.pref.access.approvals !== this.usersSitePrefsRef[this.userId].access.approvals)
                return true
            if (this.pref.access.leave !== this.usersSitePrefsRef[this.userId].access.leave)
                return true

            if (JSON.stringify(this.pref.userRestrictions || []) !== JSON.stringify(this.usersSitePrefsRef[this.userId].userRestrictions) )
                return true

            return false
        }
    },
}
</script>

<style scoped>

</style>